export default __webpack_public_path__ + "static/media/menu_bell_selected.81d79d75.svg";